import MenuProducts from "./menu-products";

export default MenuProducts;